import * as types from "./mutation-types";
import { extratores_empty } from "./getters";
import _ from "lodash";

export default {
  [types.SET_EXTRATORESLIST](state, payload) {
    state.extratores_list = payload;
  },
  [types.SET_EXTRATOR](state, payload) {
    payload = merge(extratores_empty(), payload);
    state.extratores = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
  [types.SET_LOADING](state, payload) {
    state.loading = payload;
  },
};
